import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Spinner,
} from 'reactstrap';
import { Field, Form, Formik } from 'formik';
import OtpInput from 'react-otp-input';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useState, useRef } from 'react';
import { toast } from 'react-toastify';
import { createUseStyles } from 'react-jss';
import axios from 'utils/axios';
import { useHistory } from 'react-router-dom';

const useStyles = createUseStyles({
  modal: {
    '& .modal-content': {
      width: '500px',
    },
    '& .modal-title': {
      fontSize: '17px',
    },
    '& .close': {
      display: 'none',
    },
  },
  verifyButton: {
    backgroundColor: '#2675b8',
    color: 'white',
    border: 'none',
    '&:hover': {
      backgroundColor: '#2675b8',
      color: 'white',
    },
    width: '100%',
  },
});

export default function VerifyOTPModal({
  toggleVerifyOTPModalOpen,
  verifyOTPModalOpen,
  username,
}) {
  const history = useHistory();
  const classes = useStyles();
  // const [otp, setOtp] = useState(null);
  const [verifyingOTP, setVerifyingOTP] = useState(false);
  // const [showOTPBlock, setShowOTPBlock] = useState(true);
  const [timer, setTimer] = useState(60);
  const [isSendingOTP, setSendingOTP] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    startTimer();
  }, [username]);

  const startTimer = () => {
    let initialTimer = 60;
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setTimer(initialTimer - 1);
      initialTimer -= 1;
      if (initialTimer <= 0) {
        clearInterval(timerRef.current);
        // toggleVerifyOTPModalOpen(false);
      }
    }, 1000);
  };

  async function verifyOtp(value, form) {
    try {
      if (!value.otp) {
        return toast.dark('OTP is empty.', {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setVerifyingOTP(true);
      await axios.post('/users/confirmOtp', {
        phone: username,
        code: value.otp,
      });

      // setOtp(null);
      toast.dark('OTP successfully verified', {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      toggleVerifyOTPModalOpen();
      history.push('/auth/login');
    } catch (error) {
      if (error.response?.data?.message) {
        toast.dark(error.response.data.message, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.dark(error.message, {
          position: 'top-center',
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
    setVerifyingOTP(false);
  }

  const cancelOTPLogin = () => {
    setTimer(0);
    // setShowOTPBlock(false);
    clearInterval(timerRef.current);
    toggleVerifyOTPModalOpen(false);
  };

  const sendOTPtoPhone = async (phone) => {
    if (!phone || phone === '91') console.log('Please enter phone no.');
    //setError('Please enter phone no.');
    else {
      const request = {
        username: phone,
      };
      setSendingOTP(true);
      const { data } = await axios.post(
        '/users/resendConfirmationCode',
        request,
      );
      const { CodeDeliveryDetails } = data;
      if (CodeDeliveryDetails?.DeliveryMedium === 'SMS') {
        setSendingOTP(false);
        setTimer(60);
        startTimer();
      }
    }
  };
  return (
    <Modal
      isOpen={verifyOTPModalOpen}
      toggle={toggleVerifyOTPModalOpen}
      className={classes.modal}
      backdrop={'static'}
      fade={true}
    >
      <ModalHeader
        toggle={toggleVerifyOTPModalOpen}
        style={{ marginTop: '10px' }}
        closeButton={false}
        className={classes.modalHeader}
      >
        Verify Phone Number {username}
      </ModalHeader>
      <ModalBody style={{ marginTop: '-30px' }}>
        <div className="form-group">
          <div className="row">
            <div className="col-12 ">
              {`We've sent an OTP to this phone number. Please verify your phone number by entering the OTP`}
            </div>
            <div className="col-12 mt-3">
              <Formik
                initialValues={{
                  otp: '',
                }}
                onSubmit={verifyOtp}
                // validationSchema={LoginSchema}
              >
                {({
                  values,
                  isSubmitting,
                  setFieldValue,
                  errors,
                  handleSubmit,
                }) => (
                  <Form>
                    <FormGroup className="mb-3">
                      <Field
                        component={OtpInput}
                        name="otp"
                        className="otp"
                        value={values.otp}
                        onChange={(value) => {
                          setFieldValue('otp', value);
                        }}
                        numInputs={6}
                        separator={<span>-</span>}
                        inputStyle={{ width: 40, height: 40, margin: 7 }}
                        onKeyPress={(e) => {
                          if (e.charCode === 13) handleSubmit();
                        }}
                      />
                    </FormGroup>

                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <div>
                        {true && (
                          <>
                            <small>Didn't received the code?</small>
                            &nbsp;&nbsp;
                            <Link
                              className={classes.loginWithOTP}
                              onClick={() => {
                                sendOTPtoPhone(username);
                                setFieldValue('otp', '');
                              }}
                            >
                              <small>Resend OTP</small>
                            </Link>
                            {isSendingOTP && (
                              <Spinner
                                style={{
                                  color: '#2675b8',
                                  fontSize: 5,
                                  marginLeft: 10,
                                  marginTop: 5,
                                }}
                                size="sm"
                              />
                            )}
                          </>
                        )}
                      </div>
                      <div>
                        {timer > 0 && `00:${timer < 10 ? '0' : ''}${timer}`}
                      </div>
                    </div>
                    <div className="col-12">
                      <Button
                        color="primary"
                        type="submit"
                        className={classes.verifyButton}
                        disabled={timer <= 0}
                        onClick={verifyOtp}
                      >
                        {verifyingOTP ? 'Processing...' : 'Verify OTP'}
                      </Button>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                      <Link
                        to="#"
                        className={classes.loginWithOTP}
                        onClick={() => {
                          cancelOTPLogin();
                        }}
                      >
                        <small>Cancel</small>
                      </Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}
